
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { SystemUserInterface } from '@/services/SystemUsers/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class SystemUserLogsDialog extends Vue {
  @Prop() public systemUser: SystemUserInterface;

  public visible: boolean = true;

  public deleteLog(id: number): void {
    this.$emit('deleteLog', this.systemUser.id, id);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
